import { RoutePath } from 'enums/routePath';
import allAccountOnboardingPaths from 'pages/AccountOnboardingPage/paths';
import activityMapPaths from 'pages/ActivityMapPage/paths';
import allBaseLayoutPaths from 'pages/BaseLayoutPage/paths';
import allBenchmarkingPaths from 'pages/BenchmarkingPage/paths';
import allCompaniesPaths from 'pages/CompaniesPage/paths';
import allContactsPaths from 'pages/ContactsPage/paths';
import allCoveragePaths from 'pages/CoveragePage/paths';
import allEngagementPaths from 'pages/EngagementPage/paths';
import allHomePaths from 'pages/HomePage/paths';
import allModalLayoutPaths from 'pages/ModalLayoutPage/paths';
import allProfitabilityPaths from 'pages/ProfitabilityPage/paths';
import allProspectingPaths from 'pages/ProspectingPage/paths';
import allSettingsPaths from 'pages/SettingsPage/paths';
import allTieringPaths from 'pages/TieringPage/paths';
import allTrackRevenuePaths from 'pages/TrackRevenuePage/paths';
import allWhitespacePaths from 'pages/WhitespacePage/paths';

const routePaths: Record<RoutePath, string> = {
  [RoutePath.COLOR_SPACE_TOOL]: '/color-space',
  [RoutePath.REMINDERS]: '/reminders',
  [RoutePath.REMINDERS_ARCHIVED]: '/reminders/archived',
  [RoutePath.MEETING_PLANNER]: '/meeting-planner',
  ...activityMapPaths,
  ...allAccountOnboardingPaths,
  ...allBenchmarkingPaths,
  ...allCompaniesPaths,
  ...allContactsPaths,
  ...allCoveragePaths,
  ...allHomePaths,
  ...allProfitabilityPaths,
  ...allProspectingPaths,
  ...allTrackRevenuePaths,
  ...allSettingsPaths,
  ...allTieringPaths,
  ...allWhitespacePaths,
  ...allModalLayoutPaths,
  ...allBaseLayoutPaths,
  ...allEngagementPaths,
};

export const routePathsLookup = Object.fromEntries(
  Object.entries(routePaths).map(([, val]) => {
    return [val, ''];
  }),
);

export default routePaths;
